import React from 'react';

import { useCallLogNavigate } from '_lib/callPop/useCallLogNavigate';
import { Stack, StackProps } from '_lib/components/Stack/Stack';
import { useAuthRoles } from '_lib/hooks/useAuthRoles';

import { ContrastIconButton } from '_lib/styles/PhoneCall.styled';

import symbolWhiteImage from '../../../assets/img/symbol_white.png';

export const CallDetailsFooter = (props: StackProps) => {
  const { navigateToCallLog } = useCallLogNavigate();

  const authRoles = useAuthRoles();

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      paddingLeft={2}
      paddingRight={2}
      sx={(theme) => ({
        color: theme.palette.callPane.contrastText,
        backgroundColor: theme.palette.callPane.main
      })}
      {...props}>
      <ContrastIconButton
        disabled={authRoles.isCallCenterUser || authRoles.isAccountUser}
        onClick={() => navigateToCallLog()}>
        <img src={symbolWhiteImage} alt='Logo' style={{ width: '30px' }} />
      </ContrastIconButton>
    </Stack>
  );
};
